// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB8shoW7E4X2hSLNm2irQX7QH32FoSk9NI",
  authDomain: "board-game-diagnosis.firebaseapp.com",
  projectId: "board-game-diagnosis",
  storageBucket: "board-game-diagnosis.firebasestorage.app",
  messagingSenderId: "73932714035",
  appId: "1:73932714035:web:c861bfd2e8e83e59343346",
  measurementId: "G-YV7WWSG4RX"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
